import React, { useState, useEffect } from "react";
import { CheckCircleOutlined, ClockCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Input, Row, Typography, Card, Table, Spin, Select, Tag } from "antd";
import { useNavigate } from "react-router-dom";
import MainLayout from "../../../components/layouts/MainLayout";
import { connect, useDispatch } from "react-redux";
import { labelConfig, staticConfig } from "../teller.config";
import { rightAction } from "../../../redux/actions";
import TopContent from "../../../components/layouts/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";

const { Text } = Typography;

const ManageTellerTransactions = (props) => {
  const navigate = useNavigate();
  const { rightBtn } = props;
  const [transactionList, setTransactionList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [originalList, setOriginalList] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [selectedRow, setSelectedRow] = useState(null);
  const dispatch = useDispatch();

  const columns = [
    {
      title: "Transaction Date",
      dataIndex: "transactionDate",
    },
    {
      title: "Teller Name",
      dataIndex: "tellerName",
    },
    {
      title: "Amount",
      render: (_, record) => <Text>{BOM.FormatAmount(record?.amount)}</Text>,
      dataIndex: "amount",
    },
    {
      title: "Currency",
      dataIndex: "currency",
    },
    {
      title: "Branch",
      dataIndex: "branch",
    },
    {
      title: "Transaction Description",
      dataIndex: "transactionDescription",
    },
    {
      title: "Transaction Status",
      dataIndex: "transactionStatus",
      render: (_, record) => <Text>{handleFlgStatus(record?.transactionStatus, {}, true)}</Text>,
    },
  ];

  const handleFlgStatus = (status, style = {}, isListing = false) => {
    if (!status) {
      return (
        <Tag
          icon={<ClockCircleOutlined />}
          color={`${isListing ? "warning" : "#FFEB86"}`}
          style={{ color: "black", ...style }}
        >
          -
        </Tag>
      );
    }

    switch (status.toLowerCase()) {
      case "completed":
      case "active":
        return (
          <Tag
            icon={<CheckCircleOutlined />}
            color={`${isListing ? "success" : "#87D068"}`}
            style={style}
          >
            {status}
          </Tag>
        );
      case "rejected":
      case "failed":
      case "closed":
        return (
          <Tag
            icon={<CloseCircleOutlined />}
            color={`${isListing ? "red" : "#FA0008"}`}
            style={style}
          >
            {status}
          </Tag>
        );
      default:
        return (
          <Tag
            icon={<ClockCircleOutlined />}
            color={`${isListing ? "warning" : "#FFEB86"}`}
            style={{ color: "black", ...style }}
          >
            {BOM.SubstringFormat(status, 21)}
          </Tag>
        );
    }
  };

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value?.toLowerCase();

    if (!searchKey) {
      setTransactionList(originalList);
      return;
    }
    const filterBySearch = originalList.filter(
      (item) =>
        String(item?.transactionDate ?? "")
          .toLowerCase()
          .includes(searchKey) ||
        String(item?.tellerName ?? "")
          .toLowerCase()
          .includes(searchKey) ||
        String(item?.amount ?? "")
          .toLowerCase()
          .includes(searchKey) ||
        String(item?.currency ?? "")
          .toLowerCase()
          .includes(searchKey) ||
        String(item?.branch ?? "")
          .toLowerCase()
          .includes(searchKey) ||
        String(item?.transactionDescription ?? "")
          .toLowerCase()
          .includes(searchKey) ||
        String(item?.transactionStatus ?? "")
          .toLowerCase()
          .includes(searchKey),
    );
    setTransactionList(filterBySearch);
  }

  function selectTableCount(value) {
    setTableCount(value);
  }

  useEffect(() => {
    dispatch({
      type: cnt.CLEAR_RIGHT_BTN,
    });

    const loadList = () => {
      setIsLoading(true);

      setTimeout(() => {
        const placeholder = [
          {
            key: 1,
            id: 1,
            transactionDate: "07 Apr 2026",
            tellerName: "Jane Teller",
            amount: "1250",
            currency: "USD",
            branch: "Main Office",
            transactionDescription: "Cash deposit",
            transactionStatus: "Completed",
          },
          {
            key: 2,
            id: 2,
            transactionDate: "06 Apr 2026",
            tellerName: "John Teller",
            amount: "500",
            currency: "EUR",
            branch: "North Branch",
            transactionDescription: "Vault transfer",
            transactionStatus: "Pending",
          },
        ];
        setTransactionList(placeholder);
        setOriginalList(placeholder);
        setIsLoading(false);
      }, 400);
    };

    loadList();
  }, [dispatch]);

  function handleOnView() {
    const { detailBtn } = rightBtn;
    if (detailBtn?.toLowerCase() === "primary" && selectedRow) {
      navigate("/receive-teller-transaction", {
        state: {
          id: selectedRow.id,
          transactionDate: selectedRow.transactionDate,
          description: selectedRow.transactionDescription,
          tellerName: selectedRow.tellerName,
          amount: selectedRow.amount,
          currencyCode: selectedRow.currency,
          transactionStatus: selectedRow.transactionStatus,
        },
      });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    setSelectedRow(objParam[0]);
    [cnt.RIGHT_DETAIL_BTN].forEach((item) => {
      dispatch({
        type: item,
      });
    });
  };

  return (
    <MainLayout isEnableRightSidebar={true} onView={handleOnView}>
      <TopContent
        pageTitle={labelConfig.manageTellerTransactions}
        pageItems={staticConfig.manageTellerTransactionsItems}
      />

      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Filter by teller, branch, description, status..."
                style={{
                  width: 400,
                }}
              />
            </div>
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={transactionList}
            bordered
            pagination={{
              position: ["bottomCenter"],
              pageSize: Number(tableCount),
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };

export default connect(mapStateToProps, mapDispatchToProps)(ManageTellerTransactions);
